import {ValueObject} from '@s-ui/domain'

export class IndicatorPriceValueObject extends ValueObject {
  #average
  #rank

  constructor({average, rank}) {
    super()
    this.#average = average
    this.#rank = rank
  }

  static createFromListingApi({indicator}) {
    return new IndicatorPriceValueObject({average: indicator.average, rank: indicator.rank})
  }

  get average() {
    return this.#average
  }

  get rank() {
    return this.#rank
  }

  get value() {
    return {average: this.average, rank: this.rank}
  }
}
